import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { SSQTextInput } from "src/components/SSQ/FormFields/SSQTextInput";
import { useActionsContext } from "src/context/Actions/useActionsContext";
import { CommonPropertyProps } from "./_common";
import { determineCalculationType } from "./formulaUtils";

type NumericProps = CommonPropertyProps;
export const Numeric = (props: NumericProps) => {
    const { i18n } = useTranslation();
    const { ssqVersion } = useActionsContext();
    const { property, value: initialValue, updatePropertyValue, disabled } = props;

    const [value, setValue] = useState(initialValue);
    const hasBeenChanged = useRef<boolean>(false);

    // const tooltipText = property.hint ? <div dangerouslySetInnerHTML={{ __html: property.hint }} /> : undefined;

    const onCalculate = (newValue: string) => {
        if (hasBeenChanged.current === false) return;
        hasBeenChanged.current = false;

        // Déterminer le type de calcul approprié
        const calculationType = determineCalculationType(ssqVersion, property.id, true);

        updatePropertyValue({
            serializedString: newValue,
            calculationType,
        });
    };

    return (
        <SSQTextInput
            onCalculate={onCalculate}
            // score={{
            //     score: null,
            //     unit: "",
            // }}
            value={value ?? ""}
            // tooltipText={tooltipText}
            enableLocalization={true}
            locale={i18n.resolvedLanguage || "en"}
            type={property.field?.type}
            unitTitle={property.unit?.title}
            precision={property.precision}
            onChange={(newValue) => {
                hasBeenChanged.current = true;
                setValue(newValue);
            }}
            ExtraInputProps={{
                onFocus: (e) => {
                    const isFocusDirect = !e.relatedTarget;
                    if (!isFocusDirect) {
                        return;
                    }
                },
                disabled: disabled,
                // Add data attributes for DOM targeting
                ...({
                    "data-property-id": property.id,
                    "data-testid": `property-${property.id}`,
                } as any),
            }}
        />
    );
};
